import React, { Component } from "react";
import PropTypes from "prop-types";
import { ERROR_MSG } from "../../constant";
import { Form } from "react-bootstrap";
import { debounce } from "lodash";
import { clearDebounce } from "../../helper";

const REGEX = {
  string: /([^a-z ]+)/i,
  number: /([^0-9(.{1})]+)/i
};

export class Field extends Component {
  delayUpdate = null;

  onKeyPress = e => {
    const { key } = e;
    const { strictType } = this.props;
    if (strictType) {
      const isValid = this.onStrictTypeTyping(key, strictType);
      isValid && e.preventDefault();
    }
  };

  /**
   *
   * @param e
   */
  onChange = e => {
    //
    try {
      const { onChange, keyName } = this.props;
      const { value } = e.target;
      onChange(value, keyName);
      this.onError(value);
    } catch (e) {
      console.log("Error message: - ", e.message);
    }
  };

  onError = value => {
    const { onError, delay, keyName } = this.props;
    clearDebounce(this.delayUpdate);
    this.delayUpdate = debounce(() => {
      onError(
        {
          error: !value,
          message: !value && ERROR_MSG.DEFAULT_MSG
        },
        keyName
      );
    }, delay);
    this.delayUpdate();
  };

  onStrictTypeTyping = (value, strictType, pattern) => {
    try {
      let defaultPattern;
      switch (strictType) {
        case "string":
          defaultPattern = pattern || REGEX.string;
          return defaultPattern.test(value);

        case "number":
          defaultPattern = pattern || REGEX.string;
          return defaultPattern.test(value);

        default:
          return value;
      }
    } catch (e) {
      console.log("Error message on validate - ", e.message);
    }
  };

  render() {
    return (
      <Form.Control
        {...this.props}
        onChange={this.onChange}
        onKeyPress={this.onKeyPress}
        name={""}
      >
        {this.props.children}
      </Form.Control>
    );
  }
}

Field.propTypes = {
  type: PropTypes.string,
  pattern: PropTypes.string,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  delay: PropTypes.number
};

Field.defaultProps = {
  type: "",
  pattern: "",
  onChange: () => {},
  onError: () => {},
  delay: 0
};
